export default {"src":"/login-app/[GIT_HASH]/_next/static/media/logistics.5817b6af.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};